import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Filter} from '../../report/models/filter.model';
import { SchemaForm , SchemaFormRow } from 'src/app/reports/shared/rte-form/schema/schema.model';
import { Schema } from 'src/app/reports/shared/rte-form/schema/schema.model';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';
import { IRteListButtonItem, RteFileUploader, RTEAlertService, RteDialog } from 'rte-library';
import { clearObject } from 'src/app/reports/helpers/data.helper';
import { getPropertyTypeBySystemType } from 'src/app/reports/helpers/property-type.helper';
import { PropertyType } from 'src/app/reports/shared/rte-form/schema/property-type.enum';
import { FilterTypeEnum } from 'src/app/reports/enums/filter-type.enum';
import { FileUploaderOptions } from "ng2-file-upload";
import { UploadedValuesConfirmDialogComponent } from './uploaded-values-confirm-dialog/uploaded-values-confirm-dialog.component';
import { UploadedValuesConfirmConfig, UploadValuesConfirmed } from './uploaded-values-confirm-dialog/uploaded-values-confirm.model';
import { ObjectValue } from 'src/app/reports/models/object-value.model';
import { EntityService } from '../../entity/entity.service';
import { Entity } from '../../entity/entity.model';
import { filter } from 'rxjs/operators';
import { QueryService } from 'src/app/reports/services/query.service';
import { QueryPagedRequest } from 'src/app/reports/requests/query-paged.request';
import { QueryRequest } from 'src/app/reports/requests/query.request';
import { EntityList } from 'src/app/models/entityList';

@Component({
  selector: 'app-report-form-view',
  templateUrl: './report-form-view.component.html',
  styleUrls: ['./report-form-view.component.scss']
})
export class ReportFormViewComponent extends BaseComponent implements OnInit  {

  @ViewChild('rteFileRef') rteFileRef: ElementRef;
  @Input() filters: Array<Filter> = [];
  @Input() object: any;
  @Input() form: SchemaForm;
  @Input() schemasWithFileUpload: Schema[] = [];

  lestValidation: boolean;
  filterButtons: Array<IRteListButtonItem>  = new Array<IRteListButtonItem>();
  clearFilterButton: IRteListButtonItem;

  
  uploader: RteFileUploader;

  constructor(private alert: RTEAlertService,
    private dialog: RteDialog) {
    super();
  }

  ngOnInit() {
    const option: FileUploaderOptions = {
      autoUpload: false
    };

    this.uploader = new RteFileUploader(option);
  }


  //#region Configurations

  clearObject() {
    clearObject(this.object);
  }

  //#endregion

  //#region File Upload

  onUploadFile() {
    const reader = new FileReader();
    const list = this.uploader.queue.filter(x => !x.isUploaded);

    list.forEach(element => {
      element.isUploaded = true;

      reader.addEventListener('loadend', (e: any) => {
        const value = this.extractValuesFromFile(e);

        if (value && value.length > 0) {
          this.showDialogConfirmValue(value);
        }
      });

      reader.readAsText(element._file);
    });

    this.uploader.queue = [];
    const fileUploaded = document.getElementById('attachment') as HTMLInputElement;
    fileUploaded.value = '';

  }

  showDialogConfirmValue(value: string) {
    const config: UploadedValuesConfirmConfig = {
      Schemas: this.schemasWithFileUpload,
      Value: value
    };

    this.alert.info('Por favor, verifique as informações coletadas');

    const instance = this.dialog.open(UploadedValuesConfirmDialogComponent, {
      data: config,
      width: '35vw'
    });

    this.subscription.add(
      instance.afterClosed().subscribe((result: UploadValuesConfirmed) => {
        this.object[result.Schema.PropertyName] = '';
        if (result) {
          if (this.object[result.Schema.PropertyName] == null) {
            this.object[result.Schema.PropertyName] = '';
          }

          this.object[result.Schema.PropertyName] += result.Value;
        }
      })
    );
  }

  extractValuesFromFile(e: any) {
    let value = '';
    let values = [];
    const text = e.srcElement.result + '\n';

    if (text && text.length > 0) {

      const lines = text.match(/^(.*?)?(;|,|\r\n|\n|\r)/gm);

      if (lines !== null && lines) {

        lines.forEach((line: string, index: number) => {
          if (line && line !== '') {
            const aux = this.removeFromString(line, [';', ',', /(\r\n|\n|\r)/gm]);

            if (aux && aux !== '') {
              values.push(aux);
            }
          }
        });

        values = values.filter(distinctArray);
        value = values.join(',');
      } else {
        const title = 'Arquivo não possui o formato esperado';
        const description = 'Os valores precisam estar organizados em linhas, será coletado apenas a primeira sentença de cada linha';

        this.alert.warning(title, description, { expanded: true });
      }
    } else {
      const title = 'Arquivo vazio';
      const description = 'Por favor, verifique o arquivo informado e tente novamente';

      this.alert.warning(title, description, { expanded: true});
    }

    return value;
  }

  removeFromString(word: string, exclude: any[]): string {

    exclude.forEach(element => {
      word = word.replace(element, '');
    });

    return word;
  }

  //#endregion


  
}

export function distinctArray(value, index, self) {
  return self.indexOf(value) === index;
}
